import { createSlice } from '@reduxjs/toolkit';
import { IHandleError } from 'lib/utils/redux/thunk-action-handlers';

export interface PrintSliceState extends IHandleError {
  statusMessage?: string;
  error?: Error;
}

export const initialState: PrintSliceState = {
  isLoading: false,
  hasError: false
};

const printSlice = createSlice({
  name: 'printSlice',
  initialState: initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
    },

    setProgressionStatus(state, { payload }: { payload: string }) {
      state.isLoading = true;
      state.statusMessage = payload;
    },

    setFinished(state) {
      state.isLoading = false;
      state.statusMessage = undefined;
    },
    setErrorMessage(state, args: { payload: {error: Error} }) {
      state.isLoading = false;
      state.hasError = true;
      state.statusMessage = `Print failed. ${args.payload.error}`
      state.error = args.payload.error;
    }
  }
});

export const printSliceReducer = printSlice.reducer;
export const printSliceActions = printSlice.actions;
